import { FileUploadError } from '../enums';
export class FileErrorMessageService {
    constructor() {
        this.fileUploadErrors = Array();
        this.fileUploadErrors.push(new MAX_FILE_SIZE_EXCEEDED());
        this.fileUploadErrors.push(new MAX_VIDEO_FILE_SIZE_EXCEEDED());
        this.fileUploadErrors.push(new CARRIER_CUSTOM_MESSAGE());
    }
    errorMessage(fileSize, isVideoFile, maxFileSize, maxVideoFileSize) {
        var _a;
        return (_a = this.fileUploadErrors
            .find((fileUploadErrorMessage) => fileUploadErrorMessage.isMatch(fileSize, isVideoFile, isVideoFile ? maxVideoFileSize : maxFileSize))) === null || _a === void 0 ? void 0 : _a.message();
    }
}
class MAX_FILE_SIZE_EXCEEDED {
    constructor() {
        this.message = () => FileUploadError.MAX_FILE_SIZE_EXCEEDED;
        this.isMatch = (fileSize, isVideoFile, maxFileSize) => !isVideoFile && !!maxFileSize && fileSize > maxFileSize;
    }
}
class MAX_VIDEO_FILE_SIZE_EXCEEDED {
    constructor() {
        this.message = () => FileUploadError.MAX_VIDEO_FILE_SIZE_EXCEEDED;
        this.isMatch = (fileSize, isVideoFile, maxVideoFileSize) => isVideoFile && !!maxVideoFileSize && fileSize > maxVideoFileSize;
    }
}
class CARRIER_CUSTOM_MESSAGE {
    constructor() {
        this.message = () => FileUploadError.CARRIER_CUSTOM_MESSAGE;
        this.isMatch = (fileSize, isVideoFile, maxVideoFileSize) => isVideoFile && maxVideoFileSize === 0;
    }
}
//# sourceMappingURL=FileErrorMessageService.js.map